import { Server } from '../../units/server/server';
import IStateDetails = Server.IStateDetails;
import Utils from '../../utils/utils';

export class ServerlistItemUI {
    public serviceId: number;
    public serverId: number;
    
    public constructor(public base: HTMLElement) {
        this.serviceId = this.getServiceId();
        this.serverId = this.getServerId();
    }
    
    public getServiceId() {
        return Number(this.base.querySelectorAll('[data-service-id]')[0].getAttribute('data-service-id'));
    }
    
    public getServerId() {
        return Number(this.base.querySelectorAll('[data-server-id]')[0].getAttribute('data-server-id'));
    }
    
    public onAction(callback: (e: JQuery.ClickEvent) => void) {
        
        $(this.base).find('[data-type=\'server-action\']').on('click', (e) => {
            callback(e);
        });
    }
    
    public updateActivePlayersSlot(value: string) {
        $(this.base).find('.gamecloud__table__item--player-slots .gameserver__players_active').text(value)
    }
    
    public updateMaxPlayerSlot(value: string) {
        $(this.base).find('.gamecloud__table__item--player-slots .gameserver__players_slot').text(value)
    }
    
    public updateServername(value: string) {
        $(this.base).find('.gamecloud__table__item--name strong a').text(value);
    }
    
    public toggleStop() {
        $(this.base).find('[data-action=\'stop\']').toggle();
    }
    
    public toggleStart() {
        $(this.base).find('[data-action=\'start\']').toggle();
    }
    
    public enableStop() {
        $(this.base).find('[data-action=\'stop\']').show();
    }
    
    public enableStart() {
        $(this.base).find('[data-action=\'start\']').show();
    }
    
    public enableRestart() {
        $(this.base).find('[data-action=\'restart\']').show();
    }
    
    public enableReinstall() {
        $(this.base).find('[data-action=\'reinstall\']').show();
    }
    
    public disableStop() {
        $(this.base).find('[data-action=\'stop\']').hide();
    }
    
    public disableStart(): void {
        $(this.base).find('[data-action=\'start\']').hide();
    }
    
    public disableRestart(): void {
        $(this.base).find('[data-action=\'restart\']').hide();
    }
    
    public disableReinstall(): void {
        $(this.base).find('[data-action=\'reinstall\']').hide();
    }
    
    public destroy() {
        $(this.base).remove();
    }
    
    public showInstall(details: IStateDetails) {
        console.log(details);
        
        $(this.base).find('.installing').addClass('is-visible')
        let percentage: number = 0.0;
    
        if (details !== null)
            percentage = details.percentage;
    
        $(this.base).find('.installing__progress span').css('width', percentage + '%');
    }
    
    public hideInstall() {
        $(this.base).find('.installing').removeClass('is-visible')
    }
    
    public updateStatus(oldStatus, newStatus) {
        let statusHtmlElement: JQuery = $(this.base).find('.gamecloud__table__item--status .status');
        if (statusHtmlElement.length) {
            statusHtmlElement
                .removeClass('status--' + oldStatus.stateName.toLowerCase())
                .addClass('status--' + newStatus.stateName.toLowerCase());
            
            statusHtmlElement.children('span').text(newStatus.stateName.toLowerCase());
        }
    }
    
    public updateVoiceStatus(oldStatus, newStatus) {
        let statusHtmlElement: JQuery = $(this.base).find('.gamecloud__table__item--status .status');
        if (statusHtmlElement.length) {
            statusHtmlElement
                .removeClass('status--' + oldStatus.toLowerCase())
                .addClass('status--' + newStatus.toLowerCase());
            
            statusHtmlElement.children('span').text(newStatus.toLowerCase());
        }
    }
}
